import { render, staticRenderFns } from "./charge-shipout-cost.vue?vue&type=template&id=3008a961"
import script from "./charge-shipout-cost.vue?vue&type=script&lang=js"
export * from "./charge-shipout-cost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports